import { Col, Modal, Row, Switch } from 'antd'
import React, { useEffect, useState } from 'react'
import Input from 'components/ui/dataEntry/inputs/Input'
import { utilityService } from 'services/UtilityService'
import TextAreaInput from '../inputs/TextArea'

const RegisterDeviceModal = ({
  visible,
  onOk,
  onCancel,
  confirmLoading,
  isEditMode,
  fieldData
}) => {
  const [isDeviceIdValid, setIsDeviceIdValid] = useState(false)
  const [deviceId, setDeviceId] = useState('')
  const [isActive, setIsActive] = useState(false)
  const [description, setDescription] = useState('')
  const clearAllFields = () => {
    setDescription('')
    setIsActive(false)
    setDeviceId('')
  }
  const isSubmitButtonDisabled = (deviceId, confirmLoading) => {
    const isValid = utilityService.isValidUUID(deviceId)
    if (isValid) return false
    if (confirmLoading) return true
    return true
  }
  // when device id changes check regex and see if its valid
  useEffect(() => {
    const isValid = utilityService.isValidUUID(deviceId)
    if (!isValid) {
      setIsDeviceIdValid(false)
    } else {
      setIsDeviceIdValid(true)
    }
  }, [deviceId])

  useEffect(() => {
    clearAllFields()
  }, [])

  useEffect(() => {
    setDescription(fieldData?.description)
    setIsActive(fieldData?.active || false)
    setDeviceId(fieldData?.id)
  }, [fieldData])
  return (
    <Modal
      title={isEditMode ? 'Edit Venue Device' : 'Register Venue Devices'}
      visible={visible}
      onOk={() => {
        onOk({
          deviceId,
          isActive,
          description,
          clearAllFields
        })
        console.log('data', {
          deviceId,
          isActive,
          description,
          clearAllFields
        })
      }}
      onCancel={() => {
        onCancel()
        clearAllFields()
      }}
      className='general-modal register-venue-device-modal'
      okText='Save'
      cancelText='Cancel'
      okButtonProps={{
        disabled: isSubmitButtonDisabled(deviceId, confirmLoading)
      }}
      confirmLoading={confirmLoading}
    >
      <Row gutter={[24, 24]}>
        {
          !isEditMode &&
          <Col span={24}>
            <Input
              title='Device ID'
              placeholder='Enter Device ID'
              inputName='deviceId'
              isRequired
              value={deviceId}
              handleChange={(e) => {
                setDeviceId(e.target.value)
              }}
              isError={!!(deviceId && !isDeviceIdValid)}
              errorMessage={deviceId && !isDeviceIdValid ? 'Invalid Device ID' : ''}
            />
          </Col>
        }
        <Col span={24}>
          <TextAreaInput
            title='Description'
            placeholder='Enter description'
            inputName='description'
            // onFocus={onInputFieldFocus}
            // onBlur={onInputFieldBlur}
            value={description}
            handleChange={(e) => setDescription(e.target.value)}
            autosize={{ minRows: 5 }}
          />
        </Col>
        <Col span={24}>
          <div className='switch-inner-container'>
            <p>Active</p>
            <Switch
              checked={isActive}
              onChange={(flag) => setIsActive(flag)}
            />
          </div>
        </Col>
      </Row>
    </Modal>
  )
}

export default RegisterDeviceModal
